<template>
  <div class="foot row">
    <p class="foot text-center">Copyright © VIRUS TRACKER 2021-2022</p>
  </div>
</template>
<script>
export default{
    name: 'foot'
}
</script>
